import { render, staticRenderFns } from "./newBranch.vue?vue&type=template&id=defdba7c&scoped=true"
import script from "./newBranch.vue?vue&type=script&lang=js"
export * from "./newBranch.vue?vue&type=script&lang=js"
import style0 from "./newBranch.vue?vue&type=style&index=0&id=defdba7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defdba7c",
  null
  
)

export default component.exports